import React from "react";

import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import Box from "@mui/material/Box";

// Maps a raw suppression-term value from the API to a friendly label.
const formatSuppressionStatus = (value) => {
    if (value === undefined || value === null || value === "") {
        return "";
    }
    const normalized = String(value).toLowerCase().replace(/[\s_]+/g, "-");
    if (normalized.includes("short")) return "short-term";
    if (normalized.includes("medium")) return "medium-term";
    if (normalized.includes("long")) return "long-term";
    return String(value);
};

function QuickSearchToolbar() {
    return (
        <Box
            sx={{
                p: 0.5,
                pb: 0,
            }}
        >
            <GridToolbarQuickFilter />
        </Box>
    );
}

export default function Basic(props) {
    let rows = [];

    if (props.suppressedDevices !== undefined) {
        // Support both an array of devices and an object keyed by MAC/id.
        const entries = Array.isArray(props.suppressedDevices)
            ? props.suppressedDevices.map((item, index) => [index, item])
            : Object.keys(props.suppressedDevices).map((key) => [
                  key,
                  props.suppressedDevices[key],
              ]);

        for (const [key, device] of entries) {
            // The device value may be a string (just the MAC) or an object.
            const isObject = device !== null && typeof device === "object";

            const macAddress = isObject
                ? device.MACAddress ||
                  device.MacAddress ||
                  device.mac ||
                  device.MAC ||
                  key
                : device || key;

            const suppressionStatusRaw = isObject
                ? device.SuppressionStatus ||
                  device.SuppressionTerm ||
                  device.suppressionStatus ||
                  device.Term ||
                  device.term
                : undefined;

            rows.push({
                id: key,
                mac: macAddress,
                status: "suppressed",
                suppressionStatus: formatSuppressionStatus(suppressionStatusRaw),
            });
        }
    }

    const columns = [
        {
            headerName: "MAC Address",
            field: "mac",
            flex: 0.4,
            minWidth: 200,
        },
        {
            headerName: "Status",
            field: "status",
            flex: 0.3,
            minWidth: 150,
        },
        {
            headerName: "Suppression Status",
            field: "suppressionStatus",
            flex: 0.3,
            minWidth: 180,
        },
    ];

    return (
        <div style={{ height: 400, width: "100%" }}>
            <DataGrid
                rows={rows}
                columns={columns}
                hideFooterPagination={false}
                hideFooter={false}
                slots={{ toolbar: QuickSearchToolbar }}
                disableRowSelectionOnClick={true}
                localeText={{
                    noRowsLabel: "No Suppressed Devices Found",
                }}
                initialState={{
                    sorting: {
                        sortModel: [{ field: "mac", sort: "asc" }],
                    },
                }}
            />
        </div>
    );
}
